module.exports = __webpack_public_path__ + "static/media/great_indian_sale.bd0ce860.jpg";